import { useState, useEffect, useContext, useRef } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";

import DataTable from "examples/Tables/DataTable";

import { Card } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import UploadIcon from "@mui/icons-material/Upload";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiSelect from "components/SuiSelect";
import SuiInput from "components/SuiInput";
import SuiButton from "components/SuiButton";

import toast from "react-hot-toast";
import moment from "moment";
import { capitalCase } from "capital-case";
import qs from "query-string";

import { AccountContext } from "context/account";

import api from "services/api";
import EmptyCollectionRecord from "pages/de/collection/components/EmptyCollectionRecord";
import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";
import Avatar from "@mui/material/Avatar";

const avatarSize = 26;

const AdminCollections = ({ sharedView = false }) => {
  const [collectionList, setCollectionList] = useState([]);

  const account = useContext(AccountContext);

  const navigate = useNavigate();

  let location = useLocation();
  const url = location.href ? location.href : location.pathname + location.search;

  useEffect(() => {
    if (account.id) {
      retrieveCollections();
    }
  }, [account.id, url]);

  const retrieveCollections = async (sort = "") => {
    try {
      const { data } = await api.collections.listAdmin({ order: "-updated_at" });

      let collections = data["collections"] ? data["collections"] : [];
      setCollectionList(collections);
    } catch (err) {
      toast.error(`Retrieve collection list failed`);
      console.log(err);
    }
  };

  //List/table view
  const getCollectionTableRow = (item) => {
    const collectionMeta = item?.metadata || {};
    const storeInfo = item?.store || {};

    return {
      key: item.id,
      moodboard: item?.moodboard?.[0]?.img,

      name: item.title,
      created_at: item.created_at,
      updated_at: item.updated_at,
      season: collectionMeta?.season,
      year: collectionMeta?.year,
      brand: collectionMeta?.brand,
      styles_number: item.products.length,
      owner: storeInfo,
      ownerName: storeInfo?.name,
      action: item,
    };
  };

  const columns = [
    {
      Header: "Moodboard",
      accessor: "moodboard",
      align: "center",
      isSorted: false,
      canSort: false,
      Cell: ({ row, value }) => {
        return (
          <Link to={`/workspace/collections?id=${row?.original?.key}`}>
            <ImageCardWrapper data={value} mode={"normal"} height={60} width={60} iconMode />
          </Link>
        );
      },
    },
    {
      Header: "Name",
      accessor: "name",
      isSorted: false,
      canSort: false,
    },

    {
      Header: "Season",
      accessor: "season",
      isSorted: false,
      canSort: false,
      Cell: ({ row, value }) => {
        return value?.label;
      },
    },

    {
      Header: "# of Styles",
      accessor: "styles_number",
      isSorted: false,
      canSort: false,
    },
    {
      Header: "Year",
      accessor: "year",
      isSorted: false,
      canSort: false,
      Cell: ({ row, value }) => {
        return value ? moment(value).format("YYYY") : "";
      },
    },
    {
      Header: "Created Date",
      accessor: "created_at",
      isSorted: false,
      canSort: false,
      Cell: ({ row, value }) => {
        return value ? moment(value).format("MM/DD/YY HH:mm") : "";
      },
    },
    {
      Header: "Updated Date",
      accessor: "updated_at",
      isSorted: false,
      canSort: false,
      Cell: ({ row, value }) => {
        return value ? moment(value).format("MM/DD/YY HH:mm") : "";
      },
    },
    {
      Header: "More",
      accessor: "action",
      isSorted: false,
      canSort: false,
      Cell: ({ row, value }) => (
        <SuiBox display="flex" alignItems="center" justifyContent="center" gap={0.5}>
          <Tooltip title="View Details">
            <SuiBox component={Link} to={`/workspace/collections?id=${value.id}`}>
              <ManageSearchIcon fontSize={"small"} color="dark" />
            </SuiBox>
          </Tooltip>
        </SuiBox>
      ),
    },
    {
      Header: "Owner",
      accessor: "ownerName",
      isSorted: false,
      canSort: false,
      Cell: ({ row, value }) => {
        return (
          <SuiBox
            display="flex"
            alignItems="center"
            justifyContent="center"
            color="inherit"
            sx={{ cursor: "pointer" }}
            onClick={(e) => {
              e.stopPropagation();
              navigate(`/wall/portfolio/${row.original?.owner?.id}`);
            }}
          >
            <Avatar
              src={row.original?.owner?.metadata?.avatar}
              sx={{ width: avatarSize, height: avatarSize, mr: 0.5 }}
            />
            {value}
          </SuiBox>
        );
      },
    },
  ];
  const handleRowClick = (row) => {
    navigate(`/workspace/collections?id=${row?.original?.key}`);
    //window.open(`/workspace/collections?id=${row?.original?.key}`, "_blank");
  };
  const rows = collectionList.map((item) => getCollectionTableRow(item));

  return (
    <SuiBox my={1}>
      <div>
        <Card sx={{ p: 3 }}>
          {rows.length > 0 ? (
            <DataTable
              table={{ columns, rows: rows }}
              entriesPerPage={{ defaultValue: 20 }}
              showTotalEntries={true}
              pagination={true}
              noEndBorder
              handleRowClick={handleRowClick}
            />
          ) : null}
        </Card>
      </div>
    </SuiBox>
  );
};

export default AdminCollections;
